import { render } from "./student-wishlist.vue?vue&type=template&id=f7e096e0"
import script from "./student-wishlist.vue?vue&type=script&lang=js"
export * from "./student-wishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__